import { CardsTotalsByAccountDisplayInformation } from 'core/tarjeta/components/CardsTotalsByAccountDisplayInformation/CardsTotalsByAccountDisplayInformation';
import { CardsTotalsInfo } from 'core/tarjeta/components/CardsTotalsInfo/CardsTotalsInfo';
import { CardsTotalsByAccountContext } from 'core/tarjeta/contexts/CardsTotalsByAccountContext';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { LinkButton } from 'shared/components';
import { formatPeriodo } from 'shared/utils';

export const CardsTotalsByAccountPage = () => {
  const { cardsTotalsData, goToSearch, goToBusinessMovements, searchParams } = useContext(
    CardsTotalsByAccountContext,
  );
  return (
    <Container>
      <Row className="mb-3">
        <Col>
          <CardsTotalsByAccountDisplayInformation />
        </Col>
      </Row>

      <CardsTotalsInfo
        numeroCuenta={cardsTotalsData.cuenta?.numeroCuenta}
        cardsTotals={cardsTotalsData}
        periodo={formatPeriodo(searchParams)}
      />
      <Row>
        <Col className="text-center">
          <LinkButton
            onClick={goToBusinessMovements}
            style={{ textAlign: 'center' }}
            className="link"
          >
            Ver movimientos del centro de costo
          </LinkButton>
        </Col>
        <Col className="text-center">
          <LinkButton
            style={{ textAlign: 'center' }}
            onClick={() => goToSearch()}
            className="link"
          >
            Volver
          </LinkButton>
        </Col>
      </Row>
    </Container>
  );
};
